import * as React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { BookingDetailSection } from './SharedSections/BookingDetailSection';
import { useIntl } from 'react-intl';

export function checkInUrl(qrCodeId: string) {
	// TESTING PURPOSES
	// Uncomment return value below and replace url base
	// return `http://192.168.12.40:5023/qr-code/booking/${qrCodeId}`;

	return `${window.location.origin}/qr-code/booking/${qrCodeId}`;
}

export interface BookingDetailsQrCodeProps {
	qrCodeId?: string;
	isEventBooking: boolean;
	showQrCode: boolean;
}

function BookingDetailsQrCode({ qrCodeId, isEventBooking, showQrCode }: BookingDetailsQrCodeProps) {
	const intl = useIntl();

	const url = React.useMemo(() => {
		return qrCodeId ? checkInUrl(qrCodeId) : '';
	}, [qrCodeId]);

	if (!showQrCode || !qrCodeId) {
		return null;
	}

	const sectionContent = (
		<>
			<p>
				{isEventBooking
					? intl.formatMessage({
							id: 'event-booking-details__your-qr-ticket-section__description',
							defaultMessage: 'Use this QR code on the day',
						})
					: intl.formatMessage({
							id: 'ferry-booking-details__your-qr-ticket-section__description',
							defaultMessage: 'Use this QR code at check-in',
						})}
			</p>
			<div className="qr-outer">
				<div className="qr-inner">
					{/* Inline style is only way to set qr code size */}
					<QRCodeSVG value={url} style={{ height: '10rem', width: '10rem' }} />
				</div>
			</div>
		</>
	);

	return (
		<BookingDetailSection
			sectionName={intl.formatMessage({
				id: 'booking-details__your-qr-ticket-section__label',
				defaultMessage: 'Your ticket',
			})}
			sectionContent={sectionContent}
			sectionClassName="qr-code"
			icon={{
				name: 'confirmation_number',
				useMaterialIcons: true,
			}}
			modificationRules={{
				canEdit: false,
				editType: 'passenger',
				onEdit: () => {},
				isInvoiced: false,
			}}
		/>
	);
}

export default BookingDetailsQrCode;
